














































































































import Vue from 'vue';
import Sticky from '@/vue-components/util/Sticky.vue';
import CardHeader from '@/vue-components/util/CardHeader.vue';
import autosize from 'autosize';
import { UserWebDAO } from '@/web/dao/user/UserWebDAO';
import { SparkelloWebUser } from '@/web/model/user/SparkelloWebUser';
import VueCropper, { VueCropperMethods } from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import { storage } from '@/firebaseConfig';
import { DefaultPhotos } from 'sparkello-core';


interface ProfileEditInterface {
  user: SparkelloWebUser;
  pictureEditMode: boolean;
  photoURL: string;
}

export default Vue.component('PersonalDetails', {
  name: 'PersonalDetails',
  components: {
    Sticky,
    CardHeader,
    VueCropper,
  },
  data(): ProfileEditInterface {
    return {
      user: {} as SparkelloWebUser,
      pictureEditMode: false,
      photoURL: '',
      editMode: false,
      imgSrc: '',
      selectedImg: '',
      data: null,
      zoom: 0,
    } as ProfileEditInterface;
  },
  computed: {
    title(): string {
      return 'Sparkello - Profile';
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    displayPhoto() {
      return this.$data.selectedImg ? this.$data.selectedImg :
        (this.$data.photoURL ? this.$data.photoURL  : DefaultPhotos.getDefaultProfilePhotoForName(this.$data.user.displayName));
    },
  },
  created() {
    console.log('Loading profile');
    this.$data.user = new SparkelloWebUser(this.$store.state.currentUser);
    this.$data.photoURL = this.$data.user.firebaseUser?.photoURL ? this.$data.user?.firebaseUser?.photoURL : '';
    UserWebDAO.instance.getCurrentUser().then(user => {
      console.log('User', user);
      this.$data.user = user;
      this.$data.photoURL = this.$data.user.firebaseUser?.photoURL ?
        this.$data.user?.firebaseUser?.photoURL : '';
    });

  },
  mounted() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));
  },
  updated() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));
  },
  methods: {

    cancel() {
      this.$router.back();
    },
    async save() {
      if (this.$data.selectedImg) {
        console.log(this.$data.selectedImg);
        const dest = storage().ref('profile/images').child(this.$data.user.uid).child('profile.jpg');

        console.log(dest.fullPath);

        const metadata = {
          cacheControl: 'private,max-age=600',
          contentType: 'image/jpeg',
        };

        await dest.putString(this.$data.selectedImg, 'data_url', metadata).then((snapshot)=> {
          console.log('Saved image', snapshot);
          dest.getDownloadURL().then(url=> {
            console.log(url);
            this.$data.user.firebaseUser.updateProfile({
              photoURL: url
            });
          });
        });
      }

      UserWebDAO.instance.setCurrentUserDetails(this.$data.user).then(() => {
        console.log('Success');
      }).catch(error => {
        console.error(error);
      });


      this.$router.push('/profile');
    },
    selectImage($event) {
      console.log($event);
      this.$data.photoURL = $event;
    },
    cancelPictureEdit() {
      this.$data.imgSrc = '';
      this.$data.pictureEditMode = false;
    },
    changeEditMode(value) {
      this.$data.pictureEditMode = value;
    },
    cropImage() {
      const cropper = (this.$refs.cropper as unknown) as VueCropperMethods;

      // get image data for post processing, e.g. upload or setting image src
      cropper.getCroppedCanvas({ fillColor: '#fff' });
      this.$data.selectedImg = cropper.getCroppedCanvas(
        {
          width: 256,
          height: 256,
          minWidth: 128,
          minHeight: 128,
          maxWidth: 512,
          maxHeight: 512,
          fillColor: '#fff',
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
        })
        .toDataURL('image/jpeg', 0.8);

      this.$data.pictureEditMode = false;

      console.log( this.$data.selectedImg);
    },
    reset() {
      const cropper = (this.$refs.cropper as unknown) as VueCropperMethods;
      cropper.reset();
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const cropper = (this.$refs.cropper as unknown) as VueCropperMethods;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.$data.imgSrc = event?.target?.result;
          // rebuild cropperjs with the updated source
          cropper.replace(this.$data.imgSrc);
          this.$data.pictureEditMode = true;
        };
        reader.readAsDataURL(file);

      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      (this.$refs.input as HTMLInputElement).click();
    },
  },
});
